<template functional>
  <div>
    <el-tag :type="$options.ColorType(props)">
      {{ $options.ValueStatus(props) }}
    </el-tag>
  </div>
</template>

<script>
export default {
  name: "TagCell",

  ColorType(props) {
    if (props.rowValue == "VIEJO") {
      return "info";
    }
    if (props.rowValue == "NUEVO") {
      return "warning";
    }
    if (props.rowValue == "Mensual") {
      return "success";
    } else {
      return "danger";
    }
  },

  ValueStatus(props) {
    return "C.  " + props.rowValue;
  }
};
</script>

<style></style>
